import { Injectable } from "@angular/core";
import { CheckRegisterRequest, CheckRegisterResponse, ConfirmRegisterUserPayload, ConfirmRegisterUserResponse, MyAddressAllResponse, RegisterUserPayload, RegisterUserResponse, UpdateNamePayload } from "../../../models/user.model";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { ConfigService } from "../../config.service";
import { ApiMethodService } from "../../../../tools/services/api/method-api/apiMethod.service";
import { Observable } from "rxjs";
import { environment } from '../../../../../environments/environment';
import { RegisterMemberNewPayload } from "../../../models/member.model";
import { ParkingCardInfo, Providers, StatusAPIResponse } from "../../../models/information.model";
import { ObjectFeeResponse } from "../../../models/parking.model";
import { CityParkingDiscountByCodeResponse, EntryForDiscount, MasterProviders } from "../../../models/discount.model";
import { CreateTransactionResponse } from "../../../models/ev.model";

@Injectable({
    providedIn: 'root',
})

export class ApiParkingTransactionService {
    private tokenUrl = `${environment.apiPrivateUrl}`;

    constructor(
        private http: HttpClient,
        private configService: ConfigService,
        private apiMethods: ApiMethodService,
    ) { }
    getTransactionSite(
        token: string,
        uid: string,
        site_id: number,
    ): Observable<EntryForDiscount[]> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });

        const params = new HttpParams()
            .set('uid', uid)
            .set('site_id', site_id.toString());
        return this.http.get<EntryForDiscount[]>(
            this.tokenUrl + '/Cityparking/GetTransactionSite',
            { headers, params },
        );
    }
}